// extracted by mini-css-extract-plugin
export default {"body":"ConfirmDeleteModal_body__BtQpv","buttons":"ConfirmDeleteModal_buttons__Pg+5u"};